/** @jsx jsx */

import React, { Fragment as _, memo } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import Multichoice_v2 from './Multichoice_v2';
import Media from 'components/lib/Media';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import Answer from './Answer';
import { interactionContext } from './interactionContext';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import EditableBtn from 'components/lib/EditableBtn';
import IELayout from 'components/Layouts/IELayout';
import shouldUpdate from 'services/shouldUpdate';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { interactionContext as _interactionContext } from './interactionContext';
import MultiChoice_default from 'assets/Rectangle.png';
import hatLaptopGuy from 'assets/animations/hatLaptopGuy.js';
import { findByKeyVal_V2 } from 'services/findByKeyVal';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  Image: ({ children, ...props }) => {
    const updatedProps = {
      ...props,
    };

    if (!props.src) {
      updatedProps.placeholder = MultiChoice_default;
    }

    return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;
  },
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Video,
  Audio,
  Transcript: ({ children, props }) => {
    return children;
  },
  SVG,
  Embed,
  Media,
  MultichoiceWithText: Multichoice_v2,
  //
  Answer,
  Feedback: () => null,
  Correct: () => null,
  Incorrect: () => null,
  Attempt: () => null,
  PDF,
  OpenPDF,
  Modal: () => null,
  ...IELayout(interactionContext),
};

const MultichoiceDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const hasAttemptFeedback = findByKeyVal_V2(
    interactionBlock.id,
    'type',
    'Attempt'
  );

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          updateItemsSeen: null,
          hasAttemptFeedback,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default MultichoiceDisplay;
